// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eu-expandertext-container{cursor:pointer;display:flex;justify-content:center;width:100%}.eu-expandertext-container .eu-expander-text{font-size:12px;color:#1253a4;color:var(--color-expander-text,var(--color-default,#1253a4));padding-right:8px}.eu-expandertext-container .eu-expander-icon{transition:transform .2s ease;height:18px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
